import { useRouter } from "next/router";
import { isAddress } from "viem";
import type { Address } from "viem";
import { useAccount as useWagmiAccount } from "wagmi";

export default function useAccount() {
	const {
		address: account,
		connector,
		isConnected,
		isConnecting,
		...rest
	} = useWagmiAccount();
	const {
		query: { account: queryAccount },
	} = useRouter();
	const assumedAccount = isAddress(queryAccount as Address)
		? (queryAccount as Address)
		: null;

	return {
		...rest,
		account: assumedAccount || account,
		active: assumedAccount ? true : isConnected,
		assumedAccount,
		connector,
		isConnected,
		isConnecting,
		realAccount: account,
	};
}
